<template>
  <div class="classification">
    <div class="pretrain-header header">
      <h3 class="title">{{ modelTypeCompany(modelType) }}分类</h3>
    </div>
    <div class="main">
      <div class="dataset-get">
        <div class="tool-wrap">
          <div class="select-tool">
            <span class="label">
              <i class="required">*</i>
              选择数据集：
            </span>
            <el-select
              class="select-box"
              v-model="datasetName"
              placeholder="请选择"
              filterable
              :disabled ="originTemp=='modelList'"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="select-tool">
            <span class="label">
              <i class="required">*</i>
              选择数据集版本：
            </span>
            <el-select
              class="select-box"
              v-model="activeDataset"
              placeholder="请选择"
              filterable
              :disabled ="originTemp=='modelList'"
            >
              <el-option
                v-for="item in versionList"
                :key="item.datasetId"
                :label="item.version"
                :value="item.datasetId"
                
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <el-button
          class="image-filtering-button"
          :class="{ 'events-disable': isRelease == 1 }"
          type="primary"
          @click="onImageFiltering"
          v-if="modelType == 1 || modelType == 2"
          v-show="activeDataset"
          >图像筛选</el-button
        >
      </div>

      <div
        class="condition-screening"
        v-if="modelType == 1 || modelType == 2"
        v-show="activeDataset"
      >
        <ul>
          <li
            v-for="(item, index) in conditionNav"
            :key="index"
            @click="onSelectRadio(index)"
          >
            <i
              :class="[
                selectCondition === index ? 'el-icon-check i-select' : '',
              ]"
            ></i>
            <span :class="[selectCondition === index ? 'span-select' : '']">{{
              item
            }}</span>
          </li>
        </ul>
      </div>

      <!-- 选定数据集后显示 -->
      <div class="bnts-tag" v-show="activeDataset">
        <button class="btn-primary">标签筛选</button>

        <button
          class="btn-add-tag"
          title="添加标签"
          @click="activeAddTagPopup"
          :class="{ 'events-disable': isRelease == 1 }"
        ></button>

        <!-- 选定数据集和标签分类后显示 -->
        <el-button
          type="primary"
          class="camera-upload btn-primary"
          :class="{'events-disable':isRelease ==1}"
          @click="onCameraAcquisition"
          v-show="modelType == 1 && activeDataset && activeLabel"
          >摄像头采集</el-button
        >
        <el-button
          type="primary"
          class="quote-upload btn-primary"
          :class="{ 'events-disable': isRelease == 1 }"
          @click="quoteDataset"
          v-show="activeDataset && activeLabel"
          >引用数据集</el-button
        >
        <el-button
          type="primary"
          class="btn-upload btn-primary"
          :class="{ 'events-disable': isRelease == 1 }"
          @click="uploadPictures"
          v-show="activeDataset && activeLabel"
          >本地上传</el-button
        >
        <el-alert
          :title="
            `* 每个标签的${modelTypeCompany(modelType)}不少于20${
              modelType == 1 ? '张' : '个'
            }`
          "
          type="error"
        >
        </el-alert>
      </div>
      <!-- 有图片数据显示 -->
      <!-- 图片累计 -->
      <span class="dataset-pic-total" v-show="Pictures.total">
        {{
          `累计${Pictures.total}${
            modelType == 1 ? '张' : '个'
          }${modelTypeCompany(modelType)}`
        }}
      </span>
      <div class="group-tag">
        <a
          href="javascript:void(0);"
          v-for="(item, idx) in Label.records"
          :class="[
            'h-tag',
            activeLabel === item.labelId ? 'active' : ''
          ]"
          @click="activeCatetoryLabel(item.labelId, idx)"
          :key="idx"
        >
          <span>{{ item.labelName }}</span>
          <i
            class="btn-edit el-icon-edit-outline"
            :class="{ 'events-disable': isRelease == 1 }"
            @click.stop="
              activeRenameLabelPopup(item.labelName, item.labelId, idx)
            "
          ></i>
          <i
            class="btn-del el-icon-close"
            :class="{ 'events-disable': isRelease == 1 }"
            @click.stop="
              activeLabelDeletePopup(item.labelId, item.datasetId, idx)
            "
          ></i>
        </a>
      </div>

      <div class="picture-box">
        <!-- 图标列表 -->
        <ul class="pictures" v-if="modelType == 1 || modelType == 2">
          <li
            class="picture-item"
            v-for="(pic, idx) in Pictures.records"
            :key="idx"
          >
            <i
              class="icon-see-img"
              @click="onFilePreview(pic.imgUrl)"
              title="预览"
            ></i>
            <figure>
              <img :src="photoBaseUrl + pic.imgUrl" alt="pic.imgName" />
              <!-- 置灰膜层 -->
              <div class="film" v-if="pic.isQualified == 1"></div>
            </figure>
            <div class="btns" v-if ="isRelease != 1">
              <button
                class="btn-delete"
                :class="{ 'events-disable': isRelease == 1 }"
                @click="activeDeletePopup(pic.imgId, idx)"
              >
                删除
              </button>
              <button
                class="btn-primary"
                :class="{ 'events-disable': isRelease == 1 }"
                @click="activeRenamePopup(pic, idx)"
              >
                重命名
              </button>
            </div>
            <div class="imageSizeText">
              <span>{{ pic.imgWidth }}px*{{ pic.imgHeight }}px</span>
              <!-- <span>{{pic.imgSize}}</span> -->
              <span>{{ $util.fileSizeTranfor(pic.imgSize) }}B</span>
            </div>
            <!-- 勾选框 -->
            <el-checkbox
              class="checkbox"
              :class="{ 'events-disable': isRelease == 1 }"
              v-model="pic.checked"
              @change="handleChecked(pic, idx)"
            ></el-checkbox>
            <div class="title ellipsis" :title="pic.imgName">
              {{ pic.imgName }}
            </div>
          </li>
        </ul>
        <!-- 文本列表 -->
        <ul class="pictures" v-if="modelType == 3 || modelType == 4">
          <li
            class="picture-item"
            v-for="(pic, idx) in Pictures.records"
            :key="idx"
          >
            <i
              class="el-icon-full-screen preview-txt"
              @click="onFilePreview(pic.textUrl)"
            ></i>
            <figure class="figure-border">
              <img src="../../assets/images/txtImage@2x.png" alt />
            </figure>
            <div class="btns" v-if ="isRelease != 1">
              <button
                class="btn-delete"
                :class="{ 'events-disable': isRelease == 1 }"
                @click="activeDeletePopup(pic.textId, idx)"
              >
                删除
              </button>
              <button
                class="btn-primary"
                :class="{ 'events-disable': isRelease == 1 }"
                @click="activeRenamePopup(pic, idx)"
              >
                重命名
              </button>
            </div>
            <div class="title ellipsis" :title="pic.textName">
              {{ pic.textName }}
            </div>
          </li>
        </ul>
        <!-- 音频列表 -->
        <ul class="pictures" v-if="modelType == 5 || modelType == 6">
          <li
            class="picture-item"
            v-for="(pic, idx) in Pictures.records"
            :key="idx"
          >
            <i
              class="icon-caret-preview"
              @click="onFilePreview(pic.audioUrl)"
            ></i>
            <figure class="figure-border">
              <img
                src="../../assets/images/audioImage@2x.png"
                alt="pic.audioName"
              />
            </figure>
            <div class="btns" v-if ="isRelease != 1">
              <button
                class="btn-delete"
                :class="{ 'events-disable': isRelease == 1 }"
                @click="activeDeletePopup(pic.audioId, idx)"
              >
                删除
              </button>
              <button class="btn-primary" :class="{ 'events-disable': isRelease == 1 }" @click="activeRenamePopup(pic, idx)">
                重命名
              </button>
            </div>
            <div class="title ellipsis" :title="pic.audioName">
              {{ pic.audioName }}
            </div>
          </li>
        </ul>

        <!-- 分页 -->
        <div class="pagination">
          <el-pagination
            @current-change="handleCurrentChange"
            background
            :current-page.sync="pagination.currentPage"
            :page-size="pagination.pageSize"
            :pager-count="pagination.pagerCount"
            layout="slot, prev, pager, next"
            :total="pagination.totalCount"
            :hide-on-single-page="true"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 弹窗集 -->
    <div class="popup-list">
      <!-- 删除 -->
      <gat-popup
        :class="[
          'popup-delete popup-delete-2',
          popupActive === 'delete' || popupActive === 'label_delete'
            ? 'on'
            : 'off',
        ]"
        :title="
          popupActive === 'delete'
            ? `删除${modelTypeCompany(modelType)}`
            : '删除标签'
        "
        :primary-button="'删除'"
        @cancel="cancelPopup"
        @confirm="deleteOperate"
      >
        <template v-slot:content>
          <div class="popup-del-cnt">
            <div class="head">
              <i class="icon-box">
                <icon-base
                  class="icon-info-help"
                  :icon-name="Icons.InfoHelp.iconName"
                  v-bind="Icons.InfoHelp"
                >
                  <icon-info-help class="path-icon-info-help" />
                </icon-base>
              </i>
              <span v-show="popupActive === 'label_delete'" class="title"
                >确定删除此分类及全部{{ modelTypeCompany(modelType) }}吗？</span
              >
              <span v-show="popupActive === 'delete'" class="title"
                >确定删除此{{ modelTypeCompany(modelType) }}吗？</span
              >
            </div>
          </div>
        </template>
      </gat-popup>
      <!-- 重命名 -->
      <gat-popup
        :class="['popup-rename', popupActive === 'rename' ? 'on' : 'off']"
        :title="'重命名'"
        @cancel="cancelPopup"
        @confirm="renameOperate"
      >
        <template v-slot:content>
          <el-input
            placeholder="请输入重命名"
            v-model.trim="popupData.rename.value"
            maxlength="20"
            show-word-limit
          />
        </template>
      </gat-popup>
      <!-- 添加新标签 -->
      <gat-popup
        :class="['popup-add-tag', popupActive === 'add_tag' ? 'on' : 'off']"
        :title="'添加分类'"
        @cancel="cancelPopup"
        @confirm="addLabel"
      >
        <template v-slot:content>
          <div v-if="Label.records && Label.records.length >= 15">
            <p class="p-tip">
              单个数据集的分类标签数最多不超过15个哦~
            </p>
            <div class="button-row">
              <el-button type="primary" @click="cancelPopup"
                >我知道了</el-button
              >
            </div>
          </div>
          <div v-else>
            <el-input
              placeholder="新的分类命名"
              v-model.trim="popupData.labelName"
              maxlength="20"
              show-word-limit
            />
            <p class="tip-list">
              <i class="required">*</i>单个数据集的分类标签数最多不超过15个。
            </p>
          </div>
        </template>
      </gat-popup>
      <!-- 图片筛选弹窗 -->
      <gat-popup
        :class="[
          'popup-upload-image-filtering',
          popupActive === 'imageFiltering' ? 'on' : 'off',
        ]"
        :title="'参数设置'"
        @cancel="cancelPopup"
      >
        <template v-slot:content>
          <div class="image-filtering-parameter">
            <div class="parameter">
              <span>分辨率：</span>
              <span>
                宽度<el-input
                  v-model="parameter.minWidth"
                  @blur="onBlurParameter(parameter.minWidth)"
                  onkeyup="value=value.replace(/[^\d]/g,'')"
                  maxlength="4"
                  size="small"
                  placeholder=""
                ></el-input
                >—<el-input
                  v-model="parameter.maxWidth"
                  @blur="onBlurParameter(parameter.maxWidth)"
                  onkeyup="value=value.replace(/[^\d]/g,'')"
                  maxlength="4"
                  size="small"
                  placeholder=""
                ></el-input
                >px
              </span>
              <span>
                高度<el-input
                  v-model="parameter.minHeight"
                  @blur="onBlurParameter(parameter.minHeight)"
                  onkeyup="value=value.replace(/[^\d]/g,'')"
                  maxlength="4"
                  size="small"
                  placeholder=""
                ></el-input
                >—<el-input
                  v-model="parameter.maxHeight"
                  @blur="onBlurParameter(parameter.maxHeight)"
                  onkeyup="value=value.replace(/[^\d]/g,'')"
                  maxlength="4"
                  size="small"
                  placeholder=""
                ></el-input
                >px
              </span>
            </div>
            <p>（分辨率 最大为 2048px*2048px ，最小为 64px*64px ）</p>
            <div class="parameter parameter-size">
              <span>大小：</span>
              <span>
                <el-input
                  v-model="parameter.minSize"
                  @blur="onBlurParameterSize(parameter.minSize)"
                  onkeyup="value=value.replace(/[^\d]/g,'')"
                  maxlength="4"
                  size="small"
                  placeholder=""
                ></el-input
                >—<el-input
                  v-model="parameter.maxSize"
                  @blur="onBlurParameterSize(parameter.maxSize)"
                  onkeyup="value=value.replace(/[^\d]/g,'')"
                  maxlength="4"
                  size="small"
                  placeholder=""
                ></el-input
                >KB
              </span>
            </div>
            <p class="p-size">（图片最大为4096KB ，最小为大于0KB）</p>
          </div>
        </template>
        <template v-slot:buttons>
          <el-button class="primary" @click="confirmImageFiltering"
            >确认</el-button
          >
        </template>
      </gat-popup>
      <!-- 上传图片提示 -->
      <model-training-upload-tips
        :modelType="modelType"
        :popupActive="popupActive"
        @confirmUploadTip="confirmUploadTip"
        @cancelPopup="cancelPopup"
        @uploadNoTipChange="uploadNoTipChange"
      ></model-training-upload-tips>
      <!--文件预览-->
      <file-preview
        :modelType="modelType"
        :fileUrl="fileUrl"
        :dialogvisibleview="dialogvisibleview"
        @onClickDialog="dialogvisibleview = false"
      ></file-preview>
      <!--引用数据集弹窗-->
      <dataset-popup
        :modelType="modelType"
        :modelDatasetName="datasetName"
        :modelDatasetId="activeDataset"
        :modelLabelId="activeLabel"
        :fileNumAll="Pictures.total"
        :drawerShow="drawerShow"
        @onDrawerShow="drawerShow = false"
        @getPictureList="getPictureList"
      ></dataset-popup>
    </div>
  </div>
</template>

<script>
import GatPopup from '@/components/common/GatPopup'
import IconInfoHelp from '@/components/icons/typography/InfoHelp'
import PRETRAIN from '@/axios/pretrain/pretrain.js'
import COMMON from '@/axios/common/common.js'

import ModelTrainingUploadTips from '@/components/pretrain/ModelTrainingUploadTips.vue'
import FilePreview from '@/components/pretrain/FilePreview.vue'
import DatasetPopup from '@/components/pretrain/DatasetPopup.vue'

import { GetVerifyImgs } from '@/assets/js/mixin/mixinGetVerifyImgs.js'

export default {
  name: 'classification',
  mixins: [GetVerifyImgs],
  components: {
    GatPopup,
    IconInfoHelp,
    ModelTrainingUploadTips,
    FilePreview,
    DatasetPopup,
  },
  props: [],
  data() {
    return {
      photoBaseUrl: window.gtaAiConfig.photoDomain, // 资源平台上传基地址
      fileUrl: '',
      conditionNav: ['全部', '符合条件', '不符合条件'],
      selectCondition: 0,
      checkList: ['1'],
      // checkArr: [], 
      checked: null,
      parameter: {
        maxWidth: '',
        minWidth: '',
        maxHeight: '',
        minHeight: '',
        maxSize: '',
        minSize: '',
      },
      classifyParameterList: [],
      DatasetList: [],
      versionList: [],
      origin: null,
      originTemp: null,
      activeDataset: '',
      datasetName: '',
      isRelease: null,
      activeLabel: null,
      Label: {
        records: [],
        current: 1,
        pageSize: 30,
        total: 0,
      },
      ClassifyData: {},
      Pictures: {
        records: [],
        size: 20,
        current: 1,
        total: 0,
      },
      // 翻页
      pagination: {
        currentPage: 1,
        pageSize: 20,
        totalCount: 0,
        pagerCount: 5,
      },
      // 弹窗
      popupActive: '',
      popupData: {
        pictureId: '',
        pictureName: '',
        rename: {
          index: -1,
          value: '',
          imgName: '',
        },
        uploadNoTip: false,
        labelName: '',
        delete: {
          index: -1,
        },
        labelDelete: {
          index: -1,
          labelId: '',
          datasetId: '',
        },
      },
      errorCount: 0, // 错误计数
      Icons: {
        InfoHelp: {
          iconName: '',
          viewBox: '0 0 36 36',
          width: '36',
          height: '36',
          // iconColor: "#fff"
        },
      },
      formdata: new FormData(),
      fullscreenLoading: null, // 加载效果
      dialogvisibleview: false, // 预览文件弹窗
      drawerShow: false, // 引用数据集弹窗
    }
  },
  computed: {
    options() {
      if (!this.DatasetList) {
        return []
      }

      return this.DatasetList.map((item) => {
        return { value: item.datasetName, label: item.datasetName }
      })
    },
    token() {
      return this.$store.state.token
    },
    modelType() {
      return this.$route.params.modeltype
    },
  },
  watch: {
    token() {
      this.getDatasetPageList()
    },
    datasetName(name) {
      // 重新初始化
      if (this.origin) {
        //origin=='modelList'场景时的判断
        this.ifIsRelease()
        this.origin = null
      } else {
        this.activeDataset = ''
      }
      this.getVersionList(name)
       
    },
    activeDataset(val) {
      // console.log('activeDataset', val)
      // 重新初始化
      this.Pictures = {
        records: [],
        size: 20,
        current: 1,
        total: 0,
      }
      this.activeLabel = null

      this.ifIsRelease()

      this.getLabelList().then(() => {
        this.getPictureList()
      })
    },
    activeLabel() {
      this.getPictureList()
    },
    Pictures(pictures) {
      Object.assign(this.pagination, {
        currentPage: pictures.current,
        size: pictures.size,
        totalCount: pictures.total,
      })
    },
    'Pictures.records'(val) {
      this.imglist = []
      if (val) {
        val.forEach((item) => {
          this.imglist.push(this.photoBaseUrl + item.imgUrl)
        })
      }
    },
  },
  created() {},
  mounted() {
    this.localStorageUploadTip()

    if (this.$route.query.datasetId) {
      this.datasetName = this.$route.query.datasetName
      this.activeDataset = this.$route.query.datasetId
      this.origin = this.$route.query.origin
      this.originTemp = this.origin
      this.getVersionList(this.datasetName).then(() => {
        this.activeDataset = this.$route.query.datasetId
      })
    }
    if (this.$route.params.datasetId) {
      this.datasetName = this.$route.params.datasetName
      this.activeDataset = this.$route.params.datasetId
      this.origin = this.$route.params.origin
      this.originTemp = this.origin
      // console.log('activeDataset', this.activeDataset)
    }

    if (this.token) {
      this.getDatasetPageList().then(() => {
        if (this.activeDataset) {
          this.getLabelList().then(() => {
            this.getPictureList()
          })
        }
      })
    }
  },
  methods: {
    // 模型类别单位过滤
    modelTypeCompany(type) {
      if (type == 1 || type == 2) {
        return '图片'
      } else if (type == 3 || type == 4) {
        return '文本'
      } else if (type == 5 || type == 6) {
        return '音频'
      }
    },
    displayDocument(){
      
    },
    // 预览文件 
    onFilePreview(fileUrl) {
      this.fileUrl = this.photoBaseUrl + fileUrl
      this.dialogvisibleview = true
    },
    // 图片勾选
    handleChecked(item, index) {
      let data = {
        imgId: item.imgId, // 图片id
        isQualified: item.isQualified, // 图片是否符合条件：0为符合；1为不符合
      }

      // 修改图片是否符合条件状态
      PRETRAIN.updateImgIsQualifiedByImgId(data).then((result) => {
        if (result.isSuccess) {
          this.getPictureList(this.Pictures.current)
        } else {
          this.$message.error(result.returnMsg)
        }
      })
      // this.$forceUpdate() // 强制刷新数据
    },
    // 条件单选
    onSelectRadio(val) {
      this.selectCondition = val
      this.getPictureList()
    },
    // 获取数据集列表
    getDatasetPageList() {
      let data = {
        type: this.modelType,
      }

      return new Promise((resolve, reject) => {
        PRETRAIN.selectDataset(data).then((result) => {
          if (result.isSuccess) {
            this.DatasetList = result.data
            resolve(result.data)
          } else {
            reject(result)
          }
        })
      })
    },
    // 获取数据集版本列表
    getVersionList(datasetName) {
      let data = {
        type: this.modelType,
        datasetName,
      }
      return new Promise((resolve, reject) => {
        PRETRAIN.selectDatasetVersion(data).then((result) => {
          if (result.isSuccess) {
            this.versionList = result.data
            //origin=='dataList'场景时的判断
           this.ifIsRelease()
            resolve(result.data)
          } else {
            reject(result)
          }
        })
      })
    },
    //判断数据集版本是否已发布
    ifIsRelease(orgin) {
      let { origin, activeDataset, versionList } = this
      if (origin == 'modelList') {
        this.isRelease = 1
      } else if (versionList.length ) {
        versionList.forEach((item) => {
          if (item.datasetId == activeDataset) {
            this.isRelease = item.isRelease
          }
        })
      }
    },
    // 标签处理，标签最多 20 个
    // Label
    getLabelList() {
      var datasetId = this.activeDataset,
        data = {
          datasetId: datasetId,
          modelType: this.modelType,
        }

      return new Promise((resolve, reject) => {
        PRETRAIN.getLabelByDatasetId(data).then((result) => {
          if (result.isSuccess) {
            this.Label.records = result.data
            if (result.data.length) {
              this.activeLabel = result.data[0].labelId
            }
            resolve(result.data)
          } else {
            reject(result)
          }
        })
      })
    },
    // 检测标题命名值
    checkLabelValue(value) {
      var result = false
      if (!/^[\u4e00-\u9fa5\_A-Za-z0-9]+$/.test(value)) {
        this.$message.error('标签名称只能由汉字、字母、数字组成')
        result = true
      }

      return result
    },
    /**
     * 创建标签 分类标签  @data  "datasetId"数据集id labelName标签名称
     */
    addLabel() {
      var datasetId = this.activeDataset,
        labelName = this.popupData.labelName,
        data = {
          labelName: labelName,
          datasetId: datasetId,
        }

      // 标签命名检测，只能由汉字、字母、数字组成
      if (this.checkLabelValue(labelName)) {
        return
      }

      PRETRAIN.addLabel(data).then((result) => {
        if (result.isSuccess) {
          this.$message.success(result.returnMsg)
          this.cancelPopup() // 关闭弹窗
          if (!this.Label.records) {
            this.Label.records = []
          }

          this.getLabelList() // 获取标签列表
          this.popupData.labelName = ''
        } else {
          this.$message.error(result.returnMsg)
        }
      })
    },
    // 删除标签
    activeLabelDeletePopup(labelId, datasetId, index) {
      this.popupActive = 'label_delete'
      this.popupData.labelDelete = {
        labelId: labelId,
        datasetId: datasetId,
        index: index,
      }
    },
    deleteLabel(labelId, datasetId, index) {
      var label = this.Label.records[index],
        labelName = label.labelName,
        data = {
          labelName: labelName,
          labelId: labelId,
          datasetId: datasetId,
          datasetType:this.modelType,
          // datasetType: 1,
        }

      // 如果已激活的标签，需要删除激活
      if (labelId === this.activeLabel) {
        this.activeLabel = ''
      }
      PRETRAIN.deleteLabelBylabelId(data).then((result) => {
        if (result.isSuccess) {
          this.$message.success('已删除标签：' + labelName)
          this.Label.records.splice(index, 1)
          this.Label.total -= 1
          this.getLabelList() // 获取标签列表
          // 初始化处理
          if (this.Label.records && this.Label.records.length > 0) {
            this.activeLabel = this.Label.records[0].labelId
          } else {
            this.Pictures.records = null
            this.Pictures.total = 0
            this.pagination.totalCount =0
          }
        } else {
          this.$message.error(result.returnMsg)
        }
      })
    },
    // 数据集文件处理  根据标签id查询文件列表
    // tips:文件分类中，需要数据集和分类标签完备情况下使用
    getPictureList(current) {
      var pageIndex_ = current ? current : 1,
        pageSize = this.Pictures.size,
        data = {}

      // 分类里面数据和标签分类同时存在才能获取
      if (!this.activeDataset || !this.activeLabel) {
        return
      }

      data = {
        datasetId: this.activeDataset,
        labelId: this.activeLabel,
        pageNum: pageIndex_,
        pageSize: pageSize,
        // isQualified: this.selectCondition,
      }

      if (this.modelType == 1) {
        data.isQualified = this.selectCondition
        // 依据数据集id 和标签id请求图片列表
        return PRETRAIN.getImgBylabelId(data).then((result) => {
          if (result.isSuccess) {
            this.Pictures = result.data
            // 当前页没有文件回调获取上一页文件
            this.blackGetPictureList()
            this.Pictures.records.forEach((item) => {
              if (item.isQualified == 0) {
                item.checked = true
              } else {
                item.checked = false
              }
            })
          }
          return result
        })
      }

      if (this.modelType == 3) {
        // 依据数据集id 和标签id请求文本列表
        return PRETRAIN.getTextByLabelId(data).then((result) => {
          if (result.isSuccess) {
            this.Pictures = result.data
            // 当前页没有文件回调获取上一页文件
            this.blackGetPictureList()
          }
          return result
        })
      }

      if (this.modelType == 5) {
        // 依据数据集id 和标签id请求音频列表
        return PRETRAIN.getAudioByLabelId(data).then((result) => {
          if (result.isSuccess) {
            this.Pictures = result.data
            // 当前页没有文件回调获取上一页文件
            this.blackGetPictureList()
          }
          return result
        })
      }
    },
    // 当前页没有文件回调获取上一页文件
    blackGetPictureList() {
      if (
        this.Pictures &&
        this.Pictures.current > 1 &&
        this.Pictures.records.length === 0
      ) {
        let currentPageNum = this.Pictures.current - 1
        this.getPictureList(currentPageNum)
      }
    },

    // 激活标签选中
    activeCatetoryLabel(labelId /*, index*/) {
      this.activeLabel = labelId
    },
    // 弹窗处理
    // 取消
    cancelPopup() {
      this.popupActive = ''
      // TODO: popupData 考虑是否要清除
    },
    // 删除
    activeDeletePopup(imgId, index) {
      this.popupActive = 'delete'
      // TODO: popupData 数据添加
      this.popupData.delete.index = index
    },
    // 删除操作
    deleteOperate() {
      if (this.popupActive === 'delete') {
        if (this.modelType == 1 || this.modelType == 2) {
          this.deletePicture()
        }
        if (this.modelType == 3 || this.modelType == 4) {
          this.deletePictureTxt()
        }
        if (this.modelType == 5 || this.modelType == 6) {
          this.deletePictureAudio()
        }
      } else if (this.popupActive === 'label_delete') {
        let labelDelete = this.popupData.labelDelete,
          labelId = labelDelete.labelId,
          datasetId = labelDelete.datasetId,
          index = labelDelete.index

        this.deleteLabel(labelId, datasetId, index)
      }

      // 关闭弹窗
      this.cancelPopup()
    },
    // 删除图片
    deletePicture() {
      var deleteIndex = this.popupData.delete.index,
        image = this.Pictures.records[deleteIndex],
        data = {
          imgId: image.imgId,
          imgName: image.imgName,
        }

      PRETRAIN.deleteImgByImgId(data).then((result) => {
        if (result.isSuccess) {
          this.$message.success(`已删除图片：` + image.imgName)
          this.getPictureList(this.Pictures.current)
        } else {
          this.$message.error(result.returnMsg)
        }
      })
    },
    // 删除文本
    deletePictureTxt() {
      var deleteIndex = this.popupData.delete.index,
        text = this.Pictures.records[deleteIndex],
        data = {
          textId: text.textId,
          textName: text.textName,
        }

      PRETRAIN.deleteTextByTextId(data).then((result) => {
        if (result.isSuccess) {
          this.$message.success('已删除文本：' + text.textName)
          this.getPictureList(this.Pictures.current)
        } else {
          this.$message.error(result.returnMsg)
        }
      })
    },
    // 删除音频
    deletePictureAudio() {
      var deleteIndex = this.popupData.delete.index,
        audio = this.Pictures.records[deleteIndex],
        data = {
          audioId: audio.audioId,
          audioName: audio.audioName,
        }

      PRETRAIN.deleteAudioByAudioId(data).then((result) => {
        if (result.isSuccess) {
          this.$message.success('已删除音频：' + audio.audioName)
          this.getPictureList(this.Pictures.current)
        } else {
          this.$message.error(result.returnMsg)
        }
      })
    },
    // 标签重命名
    activeRenameLabelPopup(labelName, labelId, index) {
      this.popupActive = 'rename'
      this.popupData.rename.index = index
      this.popupData.rename.value = labelName
      this.popupData.rename.flag = 'label'
    },
    // TODO:确认标签重命名
    renameLabel() {
      // if (!this.popupData.rename.value) {
      //   return this.$message.error('重命名不能为空！')
      // }
      // 标签命名检测，只能由汉字、字母、数字组成
      if (this.checkLabelValue(this.popupData.rename.value)) {
        return
      }
      var index = this.popupData.rename.index,
        labelName = this.popupData.rename.value,
        label = this.Label.records[index],
        labelId = label.labelId,
        datasetId = label.datasetId,
        data = {}

      data = {
        labelName: labelName,
        labelId: labelId,
        datasetId: datasetId,
      }

      PRETRAIN.updateLabelBylabelId(data).then((result) => {
        if (result.isSuccess) {
          let iLabel = this.Label
          iLabel.records[index].labelName = labelName
          this.Label = iLabel
          this.cancelPopup()
          this.$message.success(result.returnMsg)
        } else {
          this.$message.error(result.returnMsg)
        }
      })
    },
    // 文件重命名
    activeRenamePopup(obj, index) {
      this.popupActive = 'rename'
      // 图片重命名
      if (this.modelType == 1 || this.modelType == 2) {
        this.popupData.rename.index = index
        this.popupData.rename.imgId = obj.imgId
        this.popupData.rename.value = obj.imgName
      }
      // 文本重命名
      if (this.modelType == 3 || this.modelType == 4) {
        this.popupData.rename.index = index
        this.popupData.rename.textId = obj.textId
        this.popupData.rename.value = obj.textName
      }
      // 音频重命名
      if (this.modelType == 5 || this.modelType == 6) {
        this.popupData.rename.index = index
        this.popupData.rename.audioId = obj.audioId
        this.popupData.rename.value = obj.audioName
      }
      this.popupData.rename.flag = 'picture'
    },
    // 确认重命名
    renameOperate() {
      // 在弹窗数据中，存放 flag
      if (this.popupData.rename.flag === 'label') {
        this.renameLabel() // 确认标签重命名
      } else if (this.popupData.rename.flag === 'picture') {
        this.renamePicture() // 确认文件重命名
      }
    },
    // TODO:确认文件重命名
    renamePicture() {
      if (!this.popupData.rename.value) {
        return this.$message.error('重命名不能为空！')
      }
      if (this.popupData.rename.value.length > 20) {
        return this.$message.error('重命名不能超过20个字符！')
      }
      // 确认图片重命名
      if (this.modelType == 1 || this.modelType == 2) {
        let renameIndex = this.popupData.rename.index,
          imgName = this.popupData.rename.value,
          imgId = this.popupData.rename.imgId,
          data = {
            imgId: imgId,
            imgName: imgName,
          },
          list = []

        PRETRAIN.updateImgByImgId(data).then((result) => {
          if (result.isSuccess) {
            list = JSON.parse(JSON.stringify(this.Pictures.records))
            list[renameIndex].imgName = imgName
            this.Pictures.records = list
            this.cancelPopup() // 关闭弹窗
            this.$message.success(result.returnMsg)
          } else {
            this.$message.error(result.returnMsg)
          }
        })
      }
      // 确认文本重命名
      if (this.modelType == 3 || this.modelType == 4) {
        let renameIndex = this.popupData.rename.index,
          textName = this.popupData.rename.value,
          textId = this.popupData.rename.textId,
          data = {
            textId: textId,
            textName: textName,
          },
          list = []

        PRETRAIN.updateTextByTextId(data).then((result) => {
          if (result.isSuccess) {
            list = JSON.parse(JSON.stringify(this.Pictures.records))
            list[renameIndex].textName = textName
            this.Pictures.records = list
            this.cancelPopup() // 关闭弹窗
            this.$message.success(result.returnMsg)
          } else {
            this.$message.error(result.returnMsg)
          }
        })
      }
      // 确认音频重命名
      if (this.modelType == 5 || this.modelType == 6) {
        let renameIndex = this.popupData.rename.index,
          audioName = this.popupData.rename.value,
          audioId = this.popupData.rename.audioId,
          data = {
            audioId: audioId,
            audioName: audioName,
          },
          list = []

        PRETRAIN.updateAudioByAudioId(data).then((result) => {
          if (result.isSuccess) {
            list = JSON.parse(JSON.stringify(this.Pictures.records))
            list[renameIndex].audioName = audioName
            this.Pictures.records = list
            this.cancelPopup() // 关闭弹窗
            this.$message.success(result.returnMsg)
          } else {
            this.$message.error(result.returnMsg)
          }
        })
      }
    },

    // 摄像头采集
    async onCameraAcquisition() {
      navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
      if(navigator.getUserMedia) {
        console.log("支持调取摄像头麦克风")
        // this.$util.getCamera(); //检测电脑设备是否已经安装了摄像头
        // let cameraFlag = JSON.parse(sessionStorage.cameraFlag);
  
        let videoNum = 0;
        let microphoneNum = 0;
        navigator.mediaDevices.enumerateDevices().then(devices =>{
          console.log('调取电脑媒体', devices);
        	devices.forEach(device =>{
        		if (device.kind === "videoinput") { // 摄像头
              videoNum++
            };
        		if (device.kind === "audioinput") { // 麦克风
              microphoneNum++
            };
        	});
          
          // 检测是否有摄像头、麦克风
          if (videoNum) {
            this.$router.push({
              name: "camera-collection-img",
              query: {
                pageType: '1', // 页面类型：1模型训练，2数据集大厅
                modelType: this.modelType,
                fileNumAll: this.Pictures.total,
                datasetId: this.activeDataset,
                datasetName: this.datasetName,
                labelId: this.activeLabel,
              }
            })
          } else {
            this.$message.error('捕获摄像头失败，请重新安装摄像头！');
          }
        }).catch(function(err) {
          this.$message.error(err.name + ": " + err.message);
        });
      } else {
        this.$message.error('抱歉不支持调取摄像头');
      }
    },
    // 引用数据集
    quoteDataset() {
      this.drawerShow = true // 打开数据集弹窗
    },
    // 文件上传
    uploadPictures() {
      if (this.Pictures.total >= 200) {
        return this.$message.error(
          `单个分类标签的${this.modelTypeCompany(
            this.modelType
          )}总数不超过200个哦~`
        )
      }
      // TODO: 数据集选定、分类标签选定
      if (!this.popupData.uploadNoTip) {
        this.activeUploadTipPopup()
      } else {
        // 直接上传
        this.uploadPicturesToDataset()
      }
    },
    // 上传图片到相应标签的数据集中
    uploadPicturesToDataset() {
      var uploadFileNode = document.createElement('input'), // 创建上传按钮
        fileList = [], // 文件列表
        self = this,
        modelType = self.modelType

      uploadFileNode.setAttribute('type', 'file') // 设置上传按钮属性
      uploadFileNode.setAttribute('multiple', 'ture') // 多文件上传
      // uploadFileNode.setAttribute("accept", "image/jpeg, image/jpg"); // 限制图片除外的文件上传
      // uploadFileNode.setAttribute('accept', 'image/*') // 限制图片除外的文件上传
      // uploadFileNode.setAttribute("enctype", "multipart/form-data;"); // 编码方式
      if (modelType == 1 || modelType == 2) {
        uploadFileNode.setAttribute('accept', 'image/jpeg, image/jpg') // 限制图片除外的文件上传
      }
      if (modelType == 3 || modelType == 4) {
        uploadFileNode.setAttribute('accept', '.txt') // 限制txt除外的文件上传
      }
      if (modelType == 5 || modelType == 6) {
        uploadFileNode.setAttribute('accept', '.mp3, .wav') // 限制.mp3|.wav音频除外的文件上传
      }

      uploadFileNode.click() // 触发上传事件

      // 上传进程
      uploadFileNode.onchange = function uploadChange(evt) {
        var formdata = new FormData(),
          formatPass = true,
          list

        // 文件装配
        fileList = evt.target.files
        // 如果存在不是 image/jpeg 格式的图片就会触发停止上传的操作
        // jpg/jpeg 是一样，同属于 image/jpeg 格式
        list = Array.from(fileList)

        if (list.length > 200) {
          return self.$message.error(`上传失败，单次上传${self.modelTypeCompany(modelType)}限制200个!`)
        }

        if (self.Pictures.total + list.length > 200) {
          return self.$message.error(`上传失败，单个分类标签的${self.modelTypeCompany(modelType)}总数不超过200个哦~`)
        }

        self.fullscreenLoading = self.$loading({
          lock: true,
          text: `${self.modelTypeCompany(modelType)}上传中请稍等...`,
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        })
        
        // 图片
        if (modelType == 1 || modelType == 2) {
          self.noFile = 0;
          list.forEach((item, index) => {
            // self.selectUploadPicSize(item, list, index);
            let typeFlag = self.$util.filesFormatCheck(item, "jpg|jpeg"); // 检验文件类型
            if (typeFlag) {
              self.noFile++
              self.$message.error(`${item.name}上传失败，只允许上传 jpg/jpeg 格式图片！`);
            } else {
              formdata.append('file', item);
            }
          });
  
          if (list.length === self.noFile) {
            return self.fullscreenLoading.close(); // 关闭Loading
          }
  
          self.UploadMultipleFileApi(formdata); // 上传图片接口调用
        }
        // 文本/音频
        if (
          modelType == 3 ||
          modelType == 4 ||
          modelType == 5 ||
          modelType == 6
        ) {
          let noFile = 0
          list.forEach(async (file) => {
            if (modelType == 3 || modelType == 4) {
              let typeFlag = self.$util.filesFormatCheck(file, 'txt')
              if (typeFlag) {
                noFile++
                self.$message.error(`${file.name}上传失败，请上传格式为txt的文件!`)
              } else if (file.size > 500 * 1024) {
                noFile++
                self.$message.error(`上传失败，文件名称为${file.name}格式过大!`)
              } else {
                formdata.append('file', file)
              }
            }
            if (modelType == 5 || modelType == 6) {
              let typeFlag = self.$util.filesFormatCheck(
                file,
                'mp3|MP3|wav|WAV'
              )
              if (typeFlag) {
                noFile++
                self.$message.error(`${file.name}上传失败，请上传格式为 wav/mp3 的音频!`)
              } else if (file.size > 5242880) {
                noFile++
                self.$message.error(`上传失败，音频名称为${file.name}格式过大!`)
              } else {
                formdata.append('file', file)
              }
            }
          })
          if (list.length === noFile) {
            return self.fullscreenLoading.close() // 关闭Loading
          }
          self.UploadMultipleFileApi(formdata) // 批量上传接口
        }
      }

      uploadFileNode.onprogress = function uploadProgress(evt) {
        console.log(evt)
      }
    },
    // async selectUploadPicSize(ev, arrList, index) {
    //   var self = this
    //   var uploadFile = ev

    //   if (uploadFile) {
    //     if (window.FileReader) {
    //       var fr = new FileReader()
    //       fr.onloadend = await async function(e) {
    //         let typeFlag = self.$util.filesFormatCheck(uploadFile, 'jpg|jpeg') // 检验文件类型
    //         if (typeFlag) {
    //           self.noFile++
    //           self.$message.error(
    //             `${uploadFile.name}上传失败，只允许上传 jpg/jpeg 格式图片！`
    //           )
    //         } else {
    //           // 声明新Image
    //           var img = new Image()
    //           // 此处不做任何压缩直接读取文件流显示为图片（可扩展为压缩图片后显示）
    //           img.src = e.target.result
    //           img.onload = await function() {
    //             // 图片格式大小尺寸区间
    //             if (uploadFile.size > 4194304) {
    //               self.noFile++
    //               self.$message.error(
    //                 `上传失败，图片名称为${uploadFile.name}格式过大！`
    //               )
    //             } else if (this.width > 2048 || this.height > 2048) {
    //               self.noFile++
    //               self.$message.error(
    //                 `上传失败，图片名称为“${uploadFile.name}”分辨率大于2048px*2048px！`
    //               )
    //             } else if (this.width < 64 || this.height < 64) {
    //               self.noFile++
    //               self.$message.error(
    //                 `上传失败，图片名称为“${uploadFile.name}”分辨率小于64px*64px！`
    //               )
    //             } else {
    //               self.formdata.append('file', uploadFile)
    //             }
    //           }
    //         }

    //         if (arrList.length === index + 1) {
    //           setTimeout(() => {
    //             if (arrList.length === self.noFile) {
    //               return self.fullscreenLoading.close() // 关闭Loading
    //             }
    //             self.UploadMultipleFileApi(self.formdata) // 上传图片接口调用
    //           }, 1000)
    //         }
    //       }
    //       fr.readAsDataURL(uploadFile)
    //     }
    //   }
    // },
    // 上传图片接口调用
    UploadMultipleFileApi(formdata) {
      let modelType = this.modelType

      COMMON.UploadMultipleFile(formdata).then((result) => {
        if (result.returnCode == 200) {
          if (modelType == 1) {
            let dataList = JSON.parse(JSON.stringify(result.data));
            let imgList = [];
            dataList.forEach((item, index) => {
              // 图片格式大小尺寸区间
              if (item.size && item.size > 4194304) {
                setTimeout(() => {
                  this.$message.error(`上传失败，图片名称为${item.fileName}格式过大！`);
                }, index*5);
              } else if (item.width&&item.width > 2048 || item.height&&item.height > 2048 ) {
                setTimeout(() => {
                  this.$message.error(`上传失败，图片名称为“${item.fileName}”分辨率大于2048px*2048px！`);
                }, index*5);
              } else if (item.width&&item.width < 64 || item.height&&item.height < 64) {
                setTimeout(() => {
                  this.$message.error( `上传失败，图片名称为“${item.fileName}”分辨率小于64px*64px！`);
                }, index*5);
              } else {
                imgList.push(item);
              }
            });
  
            if (imgList.length === 0) {
              this.fullscreenLoading.close(); // 关闭Loading
              this.formdata = new FormData();  // 释放
              return
            }
            // 校验图片jpg|jpeg
            this.verifyImgs(imgList).then(res => {
              if (res.correct && res.correct.length) {
                let data = {
                  datasetId: this.activeDataset,
                  labelId: this.activeLabel,
                  datasetImgList: []
                }
                res.correct.forEach(i => {
                  imgList.forEach(j => {
                    if (i.fileUrl.indexOf(`${j.url}`) !== -1) {
                      data.datasetImgList.push({
                        imgUrl: j.url,
                        imgName: j.fileName,
                        datasetId: this.activeDataset,
                        labelId: this.activeLabel,
                        imgWidth: j.width,
                        imgHeight: j.height,
                        imgSize: j.size,
                      });
                    }
                  });
                });
                this.uploadImg(data); // 上传到服务器的文件转存到数据库中
              }
            })
          }
          if (modelType == 3) {
            this.uploadText(result);
          }
          if (modelType == 5) {
            this.uploadAudio(result);
          }
        } else {
          this.$message.error(result.returnMsg)
          this.fullscreenLoading.close() // 关闭Loading
        }
        this.formdata = new FormData() // 释放
      }).catch((error) => {
        this.formdata = new FormData() // 释放
        this.fullscreenLoading.close() // 关闭Loading
        this.$message.error('上传失败!')
      })
    },
    // 存图片
    uploadImg(data) {
      // 上传到服务器的文件转存到数据库中
      PRETRAIN.uploadImgBylabelId(data).then((result) => {
        if (result.isSuccess) {
          // 上传成功
          this.$message.success(result.returnMsg)
          this.fullscreenLoading.close() // 关闭Loading
          // TODO:刷新图片数据
          this.getPictureList()
        } else {
          this.$message.error(result.returnMsg)
          this.fullscreenLoading.close() // 关闭Loading
        }
      })
      .catch((error) => {
        this.fullscreenLoading.close() // 关闭Loading
      })
    },
    // 存文本
    uploadText(result) {
      let data = {
        datasetId: this.activeDataset,
        labelId: this.activeLabel,
      }
      let datasetTextList = result.data.map((item) => {
        return {
          textUrl: item.url,
          textName: item.fileName,
        }
      })
      data.datasetTextList = datasetTextList
      // 上传到服务器的文件转存到数据库中;
      PRETRAIN.uploadTextByLabelId(data)
        .then((result) => {
          if (result.isSuccess) {
            // 上传成功
            this.$message.success(result.returnMsg)
            // TODO:刷新文本数据
            this.getPictureList()
            this.fullscreenLoading.close() // 关闭Loading
          } else {
            this.$message.error(result.returnMsg)
            this.fullscreenLoading.close() // 关闭Loading
          }
        })
        .catch((error) => {
          this.fullscreenLoading.close() // 关闭Loading
        })
    },
    // 存音频
    uploadAudio(result) {
      let data = {
        datasetId: this.activeDataset,
        labelId: this.activeLabel,
      }

      let datasetAudioList = result.data.map((item) => {
        return {
          audioUrl: item.url,
          audioName: item.fileName,
        }
      })
      data.datasetAudioList = datasetAudioList
      // 上传到服务器的文件转存到数据库中;
      PRETRAIN.uploadAudio(data)
        .then((result) => {
          if (result.isSuccess) {
            // 上传成功
            this.$message.success(result.returnMsg)
            // TODO:刷新音频数据
            this.getPictureList()
            this.fullscreenLoading.close() // 关闭Loading
          } else {
            this.$message.error(result.returnMsg)
            this.fullscreenLoading.close() // 关闭Loading
          }
        })
        .catch((error) => {
          this.fullscreenLoading.close() // 关闭Loading
        })
    },

    // 图片上传说明
    activeUploadTipPopup() {
      this.popupActive = 'uploadtip'
    },
    // 上传提示显示后再进行上传操作
    confirmUploadTip() {
      this.cancelPopup() // 关闭弹窗
      // TODO:上传图片事件触发
      this.uploadPicturesToDataset()
    },
    // 上传图片
    uploadNoTipChange(val) {
      this.localStorageUploadTip('save', val)
    },
    // 图片上传说明是否显示存储
    localStorageUploadTip(type, value) {
      if (type === 'save') {
        this.popupData.uploadNoTip = value
        window.localStorage.setItem(
          `__upload_classification${this.modelType}_tip__`,
          value
        )
      } else {
        let uploadNoTip = window.localStorage.getItem(
          `__upload_classification${this.modelType}_tip__`
        )
        this.popupData.uploadNoTip = uploadNoTip ? uploadNoTip : false
      }
    },
    // 图片翻页
    handleCurrentChange(current) {
      this.getPictureList(current)
    },
    // 添加标签--最多能创建 15 个标签分类
    activeAddTagPopup() {
      this.popupData.labelName = ''
      if (!this.activeDataset) {
        return this.$message.warning('请选择数据集再进行标签操作')
      }
      this.popupActive = 'add_tag'
    },

    // 图片筛选
    onImageFiltering() {
      this.popupActive = 'imageFiltering'
      this.parameter = {
        maxWidth: '',
        minWidth: '',
        maxHeight: '',
        minHeight: '',
        maxSize: '',
        minSize: '',
      }

      if (this.activeDataset) {
        let data = {
          behaviorType: 1, // 类型1为：获取图片筛选设置的参数
          datasetId: this.activeDataset, // 数据集id
        }
        // 查询图片设置参数
        PRETRAIN.getBehaviorByDatasetId(data).then((result) => {
          if (result.isSuccess && result.data !== null) {
            if (result.data.behaviorRecord) {
              let behaviorRecord = JSON.parse(result.data.behaviorRecord)
              this.parameter = {
                maxWidth:
                  behaviorRecord.imgWidthMax == 0
                    ? ''
                    : behaviorRecord.imgWidthMax,
                minWidth:
                  behaviorRecord.imgWidthMin == 0
                    ? ''
                    : behaviorRecord.imgWidthMin,
                maxHeight:
                  behaviorRecord.imgHeightMax == 0
                    ? ''
                    : behaviorRecord.imgHeightMax,
                minHeight:
                  behaviorRecord.imgHeightMin == 0
                    ? ''
                    : behaviorRecord.imgHeightMin,
                maxSize:
                  behaviorRecord.imgSizeMax == 0
                    ? ''
                    : behaviorRecord.imgSizeMax / 1024,
                minSize:
                  behaviorRecord.imgSizeMin == 0
                    ? ''
                    : behaviorRecord.imgSizeMin / 1024,
              }
            }
          }
        })
      }
    },
    // 图片筛选数据检验
    onBlurParameter(val) {
      if (val && val < 64) {
        this.$message.warning('低于最小分辨率64px，请修改分辨率参数！')
      }
      if (val && val > 2048) {
        this.$message.warning('超过最大分辨率2048px，请修改分辨率参数！')
      }
    },
    onBlurParameterSize(val) {
      if (val && val == 0) {
        this.$message.warning('图片最小不能为 0 KB，请修改图片大小参数！')
      }
      if (val && val > 4096) {
        this.$message.warning('超过4096KB图片过大，请修改图片大小参数！')
      }
    },
    // 确认图片筛选数据
    confirmImageFiltering() {
      if (
        !this.parameter.maxWidth &&
        !this.parameter.minWidth &&
        !this.parameter.maxHeight &&
        !this.parameter.minHeight &&
        !this.parameter.maxSize &&
        !this.parameter.minSize
      ) {
        return this.$message.warning('请输入图片分辨率或图片大小参数！')
      } else {
        if (
          this.parameter.maxWidth ||
          this.parameter.minWidth ||
          this.parameter.maxHeight ||
          this.parameter.minHeight
        ) {
          if (
            (this.parameter.maxWidth && this.parameter.maxWidth > 2048) ||
            (this.parameter.minWidth && this.parameter.minWidth > 2048) ||
            (this.parameter.maxHeight && this.parameter.maxHeight > 2048) ||
            (this.parameter.minHeight && this.parameter.minHeight > 2048)
          ) {
            return this.$message.warning(
              '超过最大分辨率2048px，请修改分辨率参数！'
            )
          }
          if (
            (this.parameter.maxWidth && this.parameter.maxWidth < 64) ||
            (this.parameter.minWidth && this.parameter.minWidth < 64) ||
            (this.parameter.maxHeight && this.parameter.maxHeight < 64) ||
            (this.parameter.minHeight && this.parameter.minHeight < 64)
          ) {
            return this.$message.warning(
              '低于最小分辨率64px，请修改分辨率参数！'
            )
          }
          if (
            !this.parameter.maxWidth ||
            !this.parameter.minWidth ||
            !this.parameter.maxHeight ||
            !this.parameter.minHeight
          ) {
            return this.$message.warning('请补全图片分辨率参数！')
          }
        }

        if (this.parameter.maxSize || this.parameter.minSize) {
          if (!this.parameter.maxSize || !this.parameter.minSize) {
            return this.$message.warning('请补全图片大小参数！')
          }
          if (this.parameter.maxSize > 4096 || this.parameter.minSize > 4096) {
            return this.$message.warning(
              '超过4096KB图片过大，请修改图片大小参数！'
            )
          }
          if (this.parameter.maxSize < 1 || this.parameter.minSize < 1) {
            return this.$message.warning(
              '图片最小不能为 0 KB，请修改图片大小参数！'
            )
          }
        }
      }

      let maxWidth = Number(this.parameter.maxWidth),
        minWidth = Number(this.parameter.minWidth),
        maxHeight = Number(this.parameter.maxHeight),
        minHeight = Number(this.parameter.minHeight),
        maxSize = Number(this.parameter.maxSize),
        minSize = Number(this.parameter.minSize)

      let imgWidthMax = maxWidth >= minWidth ? maxWidth : minWidth,
        imgWidthMin = minWidth <= maxWidth ? minWidth : maxWidth,
        imgHeightMax = maxHeight >= minHeight ? maxHeight : minHeight,
        imgHeightMin = minHeight <= maxHeight ? minHeight : maxHeight,
        imgSizeMax = maxSize >= minSize ? maxSize : minSize,
        imgSizeMin = minSize <= maxSize ? minSize : maxSize,
        params = {
          datasetId: this.activeDataset,
          imgWidthMax: imgWidthMax,
          imgWidthMin: imgWidthMin,
          imgHeightMax: imgHeightMax,
          imgHeightMin: imgHeightMin,
          imgSizeMax: imgSizeMax * 1024,
          imgSizeMin: imgSizeMin * 1024,
        }

      // 根据用户设置筛选图片
      PRETRAIN.screenImg(params).then((result) => {
        if (result.isSuccess) {
          this.$message.success(result.returnMsg)
          this.popupActive = ''
          this.getPictureList(this.Pictures.current)
        } else {
          this.$message.error(result.returnMsg)
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import './pretrain_common.scss';
@import './Classification.scss';
</style>